jQuery(document).ready(function($){
  $('.footer__block--links p.h4, .footer__block--text p.h4').click(function(){
    $(this).parents('.footer__block').toggleClass('open');
  });
  
  $('.cat-tab-nav-item').click(function(){
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    let tab = $(this).data('id');
    $(this).closest('.cat-tab-wrapper').find('.cat-tab-item').removeClass('active');
    $('#' + tab).addClass('active');
  }); 

  // Product Fake Description Function
  if ($( ".fake-description" ).length > 0){
    let detail = $( "#custom_detail" ).html();
    $("div.description_detail").append(detail);
  }

  $(document).on('click', '.drawer-filter-item-wrapper .checkbox-control', function(){
    $('#facets-drawer .close-filter-drawer').click();
  });
});